module.exports = __webpack_public_path__ + "static/media/institucional_icon_press.76cb2068.svg";